export default __webpack_public_path__ + "static/media/brand-logo.281bf02c.svg";